import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url:'https://backend.peaklink.sy/api/',
    service_data: [],
    partner_data: [],
    about_section_data: [],
    client_data: [],
    product_type_data: [],

    contact_data:{
      whatsapp: null,
      phone: null,
      facebook: null,
      insta: null,
      whatsapp_link: '',
      phone_link: '',
      email: '',
      location: '',
      location_link: '',
      email_link: '',
      linkedin: null,
    },
    get_contact: false,

    product_data: [],
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
